import { useState, FormEvent } from "react";
import Navbar from "../../../components/layout/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../components/Button";
import { usePasswordResetMutation } from "../../../services/authApi";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [passwordReset, { isLoading }] = usePasswordResetMutation();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await passwordReset({ email }).unwrap();
      // Store email for display on the check reset page
      localStorage.setItem("resetEmail", email);
      navigate("/mail-reset");
    } catch (error) {
      console.error("Password reset request failed:", error);
      // You could add error state handling here
    }
  };

  return (
    <div>
      <Navbar />
      <div className="p-5 h-[81vh] sm:p-14 flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className=" sm:p-10 rounded-2xl sm:border border-[#7E57C233]  w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20 ">
            <div className="flex flex-col gap-6 items-start justify-start w-[500px]">
              <h2 className="">Reset Password</h2>
              <form
                onSubmit={handleSubmit}
                className="flex flex-col items-start justify-center gap-10 w-full"
              >
                <div className="flex items-start justify-center flex-col gap-1.5 w-full">
                  <label htmlFor="email" className="text-[#666666CC]">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="johndoe@mail.com"
                    className="h-11 w-full border border-[#66666659] rounded-lg outline-0 px-3"
                    required
                  />
                </div>
                <Button
                  text={isLoading ? "Sending..." : "Reset Password"}
                  disabled={isLoading}
                />
              </form>
            </div>
            <img
              src="/assets/Jellosite-Logo-09.jpg"
              alt=""
              className="w-[250px] hidden md:block"
            />
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%]  items-center justify-end mt-1 ">
            <Link to="">
              <li>Help</li>
            </Link>
            <Link to="">
              <li>Privacy</li>
            </Link>
            <Link to="">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
